import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import moment from 'moment-timezone';
import { Chip } from "@mui/material";

export const DuplicateImageFile = ({ isOpen, onClose, img }) => {
  const [confidenceLevel, setConfidenceLevel] = useState(0);

  useEffect(() => {
    if (img) setConfidenceLevel(img.duplicates[0].confidence_level)
  }, [img])

  return (
    <>
      <Modal className="duplicateModal" isOpen={isOpen} toggle={onClose}>
        <ModalHeader toggle={onClose}>Duplicate Images Found</ModalHeader>
        <ModalBody>
          <div
            style={{
              display: "flex",
              justifyContent: 'center',
              columnGap: 20,
            }}
          >
            {img.duplicates && img.duplicates.map((duplicate, index) => {
              return (
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', rowGap: '10px', position: 'relative'}}>
                  <img src={duplicate.duplicate_with} style={{width: '300px', height: '400px', objectFit: 'cover'}}></img>
                  <div style={{fontSize: 14, fontWeight: 800}}>Original</div>
                  <p style={{fontSize: 12}}>Recieved at: <span style={{fontWeight: '800'}}>{moment.tz(duplicate.original_uploaded_at, 'America/Los_Angeles').format('MM/DD/YYYY')}</span></p>
                </div>
              )
            })}
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', rowGap: '10px', position: 'relative'}}>
                <img src={img.url} style={{width: '300px', height: '400px', objectFit: 'cover'}}></img>
                <div style={{fontSize: 14, fontWeight: 800}}>Duplicate</div>
                <Chip label={`Confidence: ${(confidenceLevel * 100).toFixed(1)}%`} style={{backgroundColor: '#B93A76', color: 'white' ,display: 'flex', position: 'absolute', top: 10, right: '50%', transform: 'translateX(50%)'}} />
                <p style={{fontSize: 12}}>Recieved at: <span style={{fontWeight: '800'}}>{moment.tz(img.uploaded_at, 'America/Los_Angeles').format('MM/DD/YYYY')}</span></p>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};
